import { TextArea, Box } from '@usealloy/component-library';
import styled from 'styled-components';


export const StyledAttributeFormContainer = styled(Box)`
  &&& {
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    overflow-x: auto;
    padding: var(--cl-space-4) var(--cl-space-6);
    gap: var(--cl-space-4);
  }
`;

export const StyledLeftColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 44%;
  gap: var(--cl-space-3);
`;

interface StyledRightColumnContainerProps {
  isPublishedAttribute: boolean;
}

export const StyledRightColumnContainer = styled.div<StyledRightColumnContainerProps>`
  display: flex;
  flex-direction: column;
  flex-basis: 51%;
  gap: var(--cl-space-4);
  ${({ isPublishedAttribute }) => !isPublishedAttribute
    && 'padding-top: var(--cl-space-5)'}
`;


export const StyledTextArea = styled(TextArea)`
  &&& {
    resize: vertical;
    line-height: 1.5;
  }
`;

export const StyledDatePickerWrapper = styled.div`
  width: 100%;

  > div {
    width: 100%;
  }
`;

export const StyledErrorText = styled.div`
  color: var(--cl-border-error);
  font-size: var(--cl-font-size-1);
`;

// todo BUILD-2768 - this should go away in favor of the TipCallout
export const StyledPublishedAttributeBanner = styled(Box)`
  &&& {
    width: fit-content;
    height: 100%;
    padding: var(--cl-space-1) var(--cl-space-3);
    border: 1px solid var(--cl-yellow-500);
    border-radius: var(--cl-radius-1);
    justify-content: flex-start;
  }
`;
